import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { DateTimeService } from '../date-time.service';
import { fade } from '../shared/animations';
import { NewsItem, NewsService } from './news.service';


@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [fade]
})

export class NewsComponent implements OnInit, OnDestroy {
  newsSubscription: Subscription;
  newsItems;
  message = 'News loading...';
  ready;
  formattedTitles = [];

  constructor(
    private newsService: NewsService,
    public dtService: DateTimeService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.newsSubscription = this.newsService.newsSubject$
      .subscribe(
        (res: NewsItem[] | string) => {
          if (typeof res === 'string') {
            this.message = res;
            return;
          }
          this.newsItems = this.colorSubString(res);
          this.message = 'News';
          setTimeout(() => {
            this.ready = true;
          }, 100);
        },
        err => {
          return console.log('error in news comp: ', err);
        }
      );
  }

  colorSubString(items: NewsItem[]) {
    for (const item of items) {
      const str = item.title;
      if (str.indexOf('nsider') > 0) {
        const index = str.indexOf('nsider');
        const styled = str.substr(0, index - 1)
          + '<span style="color:red;font-weight:bold;font-size:larger">'
          + str.substr(index - 1, 8) + '</span>'
          + str.substr(index + 7);
        item.title = styled;
        this.cdr.detectChanges();
      }
    }
    return items;
  }

  titleClicked(item: NewsItem) {
    window.open(item.link, '_blank');
  }

  ngOnDestroy() {
    this.newsSubscription.unsubscribe();
  }
}
